import { getWebAppUrl } from '@/services/admin_actions/apiUtils';
import { authService } from '@/services/authService';
import { isMobileApp } from '@/services/mobile_app/mobileAppServices';
import { useModalStore } from '@/store/modalStore';
import { useUserStore } from '@/store/userJWTStore'; // Import the user store to check authentication status 
import MembershipInfoPopUp from '@/components/SingleElements/MembershipInfoPopUp.vue';


const webRoutes = [
  {
    path: '/',
    redirect: '/dashboard',
    component: () => import('@/layouts/DefaultLayout.vue'),
    meta: { RequiresAuth: true, LogUserOut: false },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/SitePages/Dashboard.vue'),
        meta: { hideCommunitiesWidget: true, LogUserOut: false }, // Add this line to hide the communities widget
      },
      {
        path: 'app_login',
        name: 'AppLogin',
        component: () => import('@/views/SitePages/Login.vue'),
        meta: { RequiresAuth: false, LogUserOut: true },
      },
      {
        path: 'menu_login',
        name: 'ClassicLogin',
        meta: { RequiresAuth: false, LogUserOut: true },
        component: () => isMobileApp() ? import('@/views/SitePages/Login.vue')  :import('@/views/AdminPages/DynamicContent.vue'),
      },
      {
        path: 'skillstesting',
        name: 'SkillsTesting',
        component: () => import('@/views/SitePages/SkillsTesting.vue'),
        meta: { LogUserOut: false }
      },
      {
        path: 'players',
        name: 'Players',
        component: () => import('@/views/SitePages/Players.vue'),
        meta: { LogUserOut: false }

      },
      {
        path: 'info',
        name: 'Info',
        component: () => import('@/views/AdminPages/Info.vue'),
        meta: { LogUserOut: false }

      },
      {
        path: 'americano',
        name: 'Americano',
        component: () => import('@/views/SitePages/Americano.vue'),
        meta: { LogUserOut: false }
      },
      {
        path: 'boxes',
        name: 'Boxes',
        component: () => import('@/views/SitePages/Boxes.vue'),
        meta: { LogUserOut: false }

      },
      {
        path: 'box',
        name: 'Box',
        component: () => import('@/views/SitePages/BoxDetail.vue'),
        meta: { LogUserOut: false }

      },
      {
        path: 'search',
        name: 'Search',
        component: () => import('@/views/SitePages/Search.vue'),
        meta: { hideSearchWidget: true, LogUserOut : false }, // Add this line to hide the search widget
      },
      {
        path: 'invites',
        name: 'Invites',
        component: () => import('@/views/SitePages/Invites.vue'),
        meta: { LogUserOut: false }
      },
      {
        path: 'add_result',
        name: 'AddResult',
        component: () => import('@/views/SitePages/AddResult.vue'),
        meta: { LogUserOut: false }
      },
      {
        path: 'add_new_community',
        name: 'AddNewCommunity',
        component: () => import('@/views/ConfigurationPages/Add_New_Community.vue'),
        meta: { LogUserOut: false }
      },
      {
        path: 'what_if',
        name: 'WhatIf',
        component: () => import('@/views/SitePages/WhatIf.vue'),
        meta: { LogUserOut: false },
      },
      {
        path: ':catchAll(.*)',
        name: 'DynamicContent',
        component: () => import('@/views/AdminPages/DynamicContent.vue'),
        meta: { LogUserOut: false }

      },
      {
        path: 'subscribe',
        name: 'Subscribe',
        component: () => import('@/views/AdminPages/DynamicContent.vue'),
        meta: { WebRestricted: true, LogUserOut: false }, // This route is restricted to the web version only
      },
      {
        path: 'membership',
        name: 'Membership',
        component: () => import('@/views/AdminPages/DynamicContent.vue'),
        meta: { WebRestricted: true, LogUserOut: false }, // This route is restricted to the web version only
      },
      {
        path: '/debug_app',
        name: 'DebugApp',
        component: () => import('@/components/TestingComponents/UserDebugPage.vue'),
      }
    ],
  }];


const PerformWebRules = async (to: any, from: any, next: any) => {
  const userStore = useUserStore();
  const isApp = isMobileApp();
  // This function can be used to perform any additional web rules or checks
  // For example, you might want to check user permissions or set up specific configurations
  // Ensure the user is logged in on app
  if (isApp && userStore.initialized && userStore.isLoggedOut && to.meta.RequiresAuth) {
    return next('/app_login');
  }

  if (isApp && to.meta.WebRestricted) {
    // If the route is restricted to web only, take the user to an external url of the page
    const modalStore = useModalStore();
    modalStore.openModal({
      title: 'Web Access Required',
      description: 'This page is only accessible via the web version of the app.',
      component: MembershipInfoPopUp,
      options: { noPadding: false, whiteIcon: true },
    });

    //leave the user on the current page
    return next(false);
  }

}

const WebAfterRules = async (to: any, from: any) => {
  const userStore = useUserStore();
  const isApp = isMobileApp();

  if (isApp && to.meta.LogUserOut) {
    await authService.logout();
  }

}


export { PerformWebRules, WebAfterRules, webRoutes }; // Export the function for use in the router